var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-admin-wrap layout-sidebar-vertical clearfix sidebar-full"},[_c('verticalSidebar'),_c('main',[_c('div',{staticClass:"main-content-wrap mt-0 bg-off-white",class:{
        'vertical-sidebar': _vm.getVerticalSidebar.isVerticalSidebar,
        compact: _vm.getVerticalSidebar.isVerticalCompact
      }},[_c('verticalTopbar'),_c('transition',{attrs:{"name":"page","mode":"out-in"}},[_c('router-view')],1),_c('appFooter')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }